import React from 'react';
import { PrimaryButton } from './Buttons';
import { Container } from './Section';
import { SIGNUP_PATH } from '../../lib/marketing';
import { track } from '../../lib/analytics';

export const FinalCTA = ({ title = 'Your next application starts here.', desc = 'Build a stronger resume, tailor it to the role and get ready to apply.', placement = 'final' }) => (
  <section data-mobile-cta-stop className="py-16 sm:py-24">
    <Container>
      <div className="relative overflow-hidden rounded-3xl bg-primary px-6 py-14 text-center text-white sm:px-12 sm:py-20">
        <div className="grid-lines absolute inset-0 opacity-[0.12]" aria-hidden="true" />
        <div className="relative">
          <h2 className="text-[30px] font-bold leading-[1.1] tracking-tight sm:text-[36px] lg:text-[46px]">{title}</h2>
          <p className="mx-auto mt-4 max-w-xl text-[17px] leading-relaxed text-white/70 sm:text-lg">{desc}</p>
          <PrimaryButton to={SIGNUP_PATH} arrow data-testid={`${placement}-cta-button`} onClick={() => track('hero_cta_click', { placement })} className="mt-8">Build My Resume Free</PrimaryButton>
          <p className="mt-4 text-xs text-white/50">No card required · Start free</p>
        </div>
      </div>
    </Container>
  </section>
);
